import {
  faFileDownload,
  faPlus,
  faRedo,
} from '@fortawesome/pro-regular-svg-icons';
import swal from '@sweetalert/with-react';
import React, { Component } from 'react';
import ReactTable from 'react-table';
import reqwest from 'reqwest';
import settings from '../../../../../settings';
import Button from '../../../../components/Button';
import ContentBox from '../../../../components/FormArea/ContentBox';
import Dropdown from '../../../../components/Inputs/Dropdown';
import Loader from '../../../../components/Loader';

/**
 * Die Ablage kennt die Formularsaetze unter ihren Ordnernamen. In der
 * Oberflaeche steht die Bezeichnung, unter der die Anwender den Satz kennen.
 */
const FORM_SET_LABELS = {
  AssignTherapyPlace: 'Vermittlung eines Therapieplatzes',
  CreateCaseFile: 'Falldokumentation',
  CaseStatisticArchive: 'Fallstatistik (Archiv)',
  AppointmentRequest: 'Terminanfrage',
};

/**
 * Pflege der Formularvorlagen durch den Kunden (CARE-802). Ersetzt die
 * Einzelaufträge CARE-795, CARE-799 und CARE-800: Kopfzeile, Fußzeile, Logo und
 * Layout ändert der Kunde selbst, statt sie beauftragen zu müssen.
 */
class FormSets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formSets: [],
      selectedFormSet: '',
      documents: [],
      loading: true,
      uploading: false,
      dragActive: false,
      migrating: false,
    };

    // Nur ein Auswahlfeld: das Dateifenster wird aus den Schaltflächen der Zeile
    // heraus geöffnet, damit "Ersetzen" ohne Umweg funktioniert.
    this.fileInput = React.createRef();
    this.replaceTarget = null;
  }

  componentDidMount() {
    this.loadFormSets();
  }

  loadFormSets = () => {
    reqwest({
      method: 'get',
      url: settings.formsets.getFormSets,
      contentType: 'json',
      data: { Token: localStorage.getItem('token') },
    })
      .then((response) => {
        const formSets = JSON.parse(response) || [];
        this.setState({ formSets, selectedFormSet: formSets[0] || '' }, () => {
          if (this.state.selectedFormSet) {
            this.loadDocuments(this.state.selectedFormSet);
          } else {
            this.setState({ loading: false });
          }
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        this.showError('Die Formularsätze konnten nicht geladen werden.');
      });
  };

  loadDocuments = (formSet) => {
    this.setState({ loading: true });

    reqwest({
      method: 'get',
      url: settings.formsets.getDocuments,
      contentType: 'json',
      data: { Token: localStorage.getItem('token'), FormSet: formSet },
    })
      .then((response) => {
        this.setState({ documents: JSON.parse(response) || [], loading: false });
      })
      .catch(() => {
        this.setState({ documents: [], loading: false });
        this.showError('Die Vorlagen konnten nicht geladen werden.');
      });
  };

  showError = (text) => {
    swal({ title: 'Fehler', text, icon: 'error' });
  };

  /** Öffnet das Dateifenster. Mit Zieldatei, wenn eine Vorlage ersetzt wird. */
  chooseFile = (replaceFileName) => {
    this.replaceTarget = replaceFileName || null;
    if (this.fileInput.current) {
      this.fileInput.current.value = '';
      this.fileInput.current.click();
    }
  };

  onFileChosen = (event) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      this.confirmAndUpload(file);
    }
  };

  onDragOver = (event) => {
    event.preventDefault();
    if (!this.state.dragActive) {
      this.setState({ dragActive: true });
    }
  };

  onDragLeave = () => {
    this.setState({ dragActive: false });
  };

  onDrop = (event) => {
    event.preventDefault();
    this.setState({ dragActive: false });

    const files = event.dataTransfer && event.dataTransfer.files;
    if (!files || files.length === 0) {
      return;
    }
    if (files.length > 1) {
      this.showError(
        'Bitte eine Datei nach der anderen hochladen, damit die Prüfung eindeutig zugeordnet werden kann.',
      );
      return;
    }

    this.replaceTarget = null;
    this.confirmAndUpload(files[0]);
  };

  /**
   * Vor dem Hochladen wird gesagt, was passiert: Ersetzen einer bestehenden
   * Vorlage oder Anlegen einer neuen. Ein Name, der von der zu ersetzenden
   * Vorlage abweicht, würde eine zusätzliche Vorlage anlegen - darauf wird
   * ausdrücklich hingewiesen.
   */
  confirmAndUpload = async (file) => {
    const existing = this.state.documents.find((document) => {
      return (
        document.FileName &&
        document.FileName.toLowerCase() === file.name.toLowerCase()
      );
    });

    let question;
    if (this.replaceTarget && this.replaceTarget.toLowerCase() !== file.name.toLowerCase()) {
      question = (
        <div>
          <p>
            Ersetzt werden sollte <b>{this.replaceTarget}</b>, gewählt ist aber{' '}
            <b>{file.name}</b>.
          </p>
          <p>
            Damit bleibt {this.replaceTarget} unverändert und {file.name} wird
            zusätzlich angelegt. Gedruckt wird nur, was in
            FileNamesToPrint hinterlegt ist.
          </p>
        </div>
      );
    } else if (existing) {
      question = (
        <div>
          <p>
            <b>{file.name}</b> ersetzt die bisherige Vorlage.
          </p>
          <p>
            Die bisherige Fassung bleibt in der Versionshistorie der Ablage
            erhalten.
          </p>
        </div>
      );
    } else {
      question = (
        <div>
          <p>
            <b>{file.name}</b> wird als neue Vorlage hinterlegt.
          </p>
          <p>
            Gedruckt wird sie erst, wenn ihr Name in FileNamesToPrint der
            jeweiligen Dienststelle steht.
          </p>
        </div>
      );
    }

    const confirmed = await swal({
      title: 'Vorlage hochladen',
      content: question,
      buttons: ['Abbrechen', 'Hochladen'],
    });

    if (confirmed) {
      this.upload(file, false);
    }
  };

  upload = (file, ignoreUnknownPlaceholders) => {
    this.setState({ uploading: true });

    const formData = new FormData();
    formData.append('FormSet', this.state.selectedFormSet);
    formData.append('IgnoreUnknownPlaceholders', ignoreUnknownPlaceholders);
    formData.append('Token', localStorage.getItem('token'));
    formData.append('File', file, file.name);

    fetch(settings.formsets.upload, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Der Server hat mit HTTP ${response.status} geantwortet.`);
        }
        return response.text();
      })
      .then((text) => {
        this.setState({ uploading: false });
        this.handleUploadResult(JSON.parse(text), file);
      })
      .catch((error) => {
        this.setState({ uploading: false });
        this.showError(
          `Die Vorlage konnte nicht hochgeladen werden. ${error.message}`,
        );
      });
  };

  handleUploadResult = (result, file) => {
    if (result.SaveResult === 'Saved') {
      this.loadDocuments(this.state.selectedFormSet);

      if (result.UnusedPlaceholders && result.UnusedPlaceholders.length > 0) {
        // Nur ein Hinweis: eine Vorlage muss nicht jedes Feld verwenden.
        swal({
          title: 'Vorlage gespeichert',
          content: (
            <div>
              <p>
                <b>{file.name}</b> ist hinterlegt.
              </p>
              <p>
                Diese bekannten Felder kommen in der Vorlage nicht vor - falls
                das ungewollt ist, fehlt vielleicht ein Platzhalter:
              </p>
              <p className="FormSets-Placeholders">
                {result.UnusedPlaceholders.join(', ')}
              </p>
            </div>
          ),
          icon: 'success',
        });
      } else {
        swal({
          title: 'Vorlage gespeichert',
          text: `${file.name} ist hinterlegt.`,
          icon: 'success',
        });
      }
      return;
    }

    if (result.Reason === 'UnknownPlaceholders') {
      this.askAboutUnknownPlaceholders(result, file);
      return;
    }

    const reasons = {
      EmptyFile: 'Die Datei ist leer.',
      UnsupportedType:
        'Nur Word-Vorlagen (.docx) und XML-Dateien können hinterlegt werden.',
      StoreFailed:
        'Die Ablage hat die Datei nicht angenommen. Bitte den Systemadministrator informieren.',
    };

    this.showError(
      reasons[result.Reason] ||
        'Die Vorlage konnte nicht gespeichert werden.',
    );
  };

  /**
   * Der Kern der Funktion: ein Platzhalter, den das System nicht kennt, bleibt
   * im gedruckten Dokument stehen. Genau das war die Ursache von CARE-782 und
   * CARE-787 und fiel dort erst beim Anwender auf.
   */
  askAboutUnknownPlaceholders = async (result, file) => {
    const upload = await swal({
      title: 'Unbekannte Platzhalter',
      content: (
        <div>
          <p>
            <b>{file.name}</b> enthält Platzhalter, die das System nicht kennt:
          </p>
          <p className="FormSets-Placeholders">
            {result.UnknownPlaceholders.join(', ')}
          </p>
          <p>
            Diese bleiben im gedruckten Dokument unersetzt stehen. Meist ist es
            ein Schreibfehler oder das Feld ist noch nicht zugeordnet.
          </p>
        </div>
      ),
      buttons: ['Abbrechen', 'Trotzdem hochladen'],
      icon: 'warning',
    });

    if (upload) {
      this.upload(file, true);
    }
  };

  /**
   * Übernimmt die ausgelieferten Vorlagen in die Ablage. Erst danach gibt es eine
   * Versionshistorie, und erst danach lässt sich eine Änderung zurückrollen.
   * Mehrfach aufrufbar - gepflegte Fassungen bleiben unberührt.
   */
  migrate = async () => {
    const confirmed = await swal({
      title: 'Vorlagen übernehmen',
      content: (
        <div>
          <p>
            Die ausgelieferten Vorlagen werden in die Ablage übernommen. Danach
            lässt sich jede Änderung zurückrollen.
          </p>
          <p>
            Bereits selbst hochgeladene Vorlagen bleiben unverändert. Der
            Vorgang kann jederzeit wiederholt werden.
          </p>
        </div>
      ),
      buttons: ['Abbrechen', 'Übernehmen'],
    });

    if (!confirmed) {
      return;
    }

    this.setState({ migrating: true });

    const formData = new FormData();
    formData.append('FormSet', this.state.selectedFormSet);
    formData.append('Token', localStorage.getItem('token'));

    fetch(settings.formsets.migrate, { method: 'POST', body: formData })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Der Server hat mit HTTP ${response.status} geantwortet.`);
        }
        return response.text();
      })
      .then((text) => {
        this.setState({ migrating: false });
        this.showMigrationResult(JSON.parse(text));
      })
      .catch((error) => {
        this.setState({ migrating: false });
        this.showError(`Die Übernahme ist fehlgeschlagen. ${error.message}`);
      });
  };

  showMigrationResult = (result) => {
    if (result.Result !== 'Migrated') {
      this.showError(
        result.Reason === 'DirectoryMissing'
          ? 'Das Verzeichnis des Formularsatzes ist auf dem Server nicht erreichbar.'
          : 'Die Übernahme ist fehlgeschlagen.',
      );
      return;
    }

    this.loadDocuments(this.state.selectedFormSet);

    // Vorlagen mit unbekannten Platzhaltern sind der interessante Teil: sie
    // drucken heute schon unersetzte Platzhalter, es ist nur nie geprüft worden.
    const withFindings = (result.Migrated || []).filter((document) => {
      return (
        document.UnknownPlaceholders &&
        document.UnknownPlaceholders.length > 0
      );
    });

    swal({
      title: 'Übernahme abgeschlossen',
      content: (
        <div>
          <p>
            {(result.Migrated || []).length} Vorlagen übernommen,{' '}
            {(result.AlreadyPresent || []).length} waren bereits in der Ablage.
          </p>
          {result.Failed && result.Failed.length > 0 && (
            <p>
              Nicht lesbar und daher übersprungen:{' '}
              <b>{result.Failed.join(', ')}</b>
            </p>
          )}
          {withFindings.length > 0 && (
            <div>
              <p>
                In diesen Vorlagen stehen Platzhalter, die das System nicht
                kennt. Sie bleiben im gedruckten Dokument unersetzt:
              </p>
              {withFindings.map((document) => {
                return (
                  <p key={document.FileName} className="FormSets-Placeholders">
                    {document.FileName}: {document.UnknownPlaceholders.join(', ')}
                  </p>
                );
              })}
            </div>
          )}
        </div>
      ),
      icon: withFindings.length > 0 || (result.Failed || []).length > 0 ? 'warning' : 'success',
    });
  };

  download = (fileName) => {
    const parameters = new URLSearchParams({
      Token: localStorage.getItem('token'),
      FormSet: this.state.selectedFormSet,
      FileName: fileName,
    });

    fetch(`${settings.formsets.download}?${parameters.toString()}`, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Der Server hat mit HTTP ${response.status} geantwortet.`);
        }
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.showError(
          `${fileName} konnte nicht heruntergeladen werden. ${error.message}`,
        );
      });
  };

  readableSize = (bytes) => {
    const size = Number(bytes) || 0;
    if (size < 1024) {
      return `${size} B`;
    }
    if (size < 1024 * 1024) {
      return `${(size / 1024).toFixed(1)} KB`;
    }
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  };

  formSetLabel(formSet) {
    return FORM_SET_LABELS[formSet] || formSet;
  }

  renderFormSetChoice() {
    if (this.state.formSets.length <= 1) {
      return null;
    }

    return (
      <Dropdown
        label="Formularsatz:"
        name="FormSet"
        options={this.state.formSets.map((formSet) => {
          return { value: formSet, label: this.formSetLabel(formSet) };
        })}
        defaultValue={this.state.selectedFormSet}
        getSelected={(selectedFormSet) => {
          this.setState({ selectedFormSet }, () => {
            this.loadDocuments(selectedFormSet);
          });
        }}
        validator={[]}
      />
    );
  }

  renderMigrationNote() {
    const isDelivered = this.state.documents.some((document) => {
      return document.Source !== 'Ablage';
    });

    if (!isDelivered) {
      return null;
    }

    return (
      <div className="Input--fullWidth">
        <p className="FormSets-Note">
          Einzelne Vorlagen liegen noch als ausgeliefertes Original vor. Erst
          nach der Übernahme in die Ablage lässt sich eine Änderung
          zurückrollen.
        </p>
        <Button
          type="primary"
          outline
          icon={faRedo}
          loading={this.state.migrating}
          disabled={this.state.migrating}
          onClick={this.migrate}
        >
          Vorlagen in die Ablage übernehmen
        </Button>
      </div>
    );
  }

  columns() {
    return [
      {
        Header: 'Datei',
        accessor: 'FileName',
        minWidth: 240,
      },
      {
        Header: 'Quelle',
        accessor: 'Source',
        width: 140,
        Cell: ({ value }) => {
          return (
            <span
              title={
                value === 'Ablage'
                  ? 'Selbst hochgeladen - diese Fassung wird gedruckt.'
                  : 'Ausgeliefertes Original auf dem Server.'
              }
            >
              {value}
            </span>
          );
        },
      },
      {
        Header: 'Größe',
        accessor: 'FileLength',
        width: 120,
        Cell: ({ value }) => {
          return this.readableSize(value);
        },
      },
      {
        // Zeitpunkt und Bearbeiter gehoeren zusammen und stehen deshalb in
        // einer Spalte - das laesst dem Dateinamen den Platz, den er braucht.
        Header: 'Geändert',
        accessor: 'UpdateDate',
        width: 220,
        Cell: ({ original }) => {
          return (
            <>
              {original.UpdateDate}
              {original.UpdateUserName && (
                <span className="FormSets-Changed-By">
                  {original.UpdateUserName}
                </span>
              )}
            </>
          );
        },
      },
      {
        Header: 'Aktion',
        accessor: 'FileName',
        id: 'Actions',
        sortable: false,
        width: 260,
        Cell: ({ value }) => {
          return (
            <div className="FormSets-Actions">
              <Button
                small
                outline
                icon={faFileDownload}
                onClick={() => {
                  return this.download(value);
                }}
              >
                Herunterladen
              </Button>
              <Button
                small
                outline
                icon={faRedo}
                onClick={() => {
                  return this.chooseFile(value);
                }}
              >
                Ersetzen
              </Button>
            </div>
          );
        },
      },
    ];
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const documents = this.state.documents;

    return (
      <div className="Page-Content">
        <div className="Buttonbar">
          <Button
            type="primary"
            icon={faPlus}
            onClick={() => {
              return this.chooseFile(null);
            }}
          >
            Vorlage hochladen
          </Button>
        </div>

        <ContentBox title="Formularvorlagen">
          {this.renderFormSetChoice()}
          <div className="Input--fullWidth">
            <p className="FormSets-Note">
              Eine hochgeladene Fassung wird ab dem nächsten Druck verwendet.
              Das ausgelieferte Original bleibt als Rückfall erhalten.
            </p>
          </div>
          {this.renderMigrationNote()}
        </ContentBox>

        <div
          className={`FormSets-Dropzone ${
            this.state.dragActive ? 'is-Active' : ''
          }`}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
        >
          {this.state.uploading ? (
            <Loader />
          ) : (
            <>
              <p className="FormSets-Dropzone-Title">Vorlage hier ablegen</p>
              <p className="FormSets-Hint">
                Word-Vorlagen (.docx) werden beim Hochladen auf unbekannte
                Platzhalter geprüft.
              </p>
            </>
          )}
        </div>

        <input
          type="file"
          ref={this.fileInput}
          accept=".docx,.xml"
          className="FormSets-FileInput"
          onChange={this.onFileChosen}
        />

        <ReactTable
          className="FormSets-Table"
          data={documents}
          pageSize={documents.length || 1}
          noDataText="Es liegen keine Vorlagen vor."
          columns={this.columns()}
        />
      </div>
    );
  }
}

export default FormSets;
